export default class TypRezieService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listUserTags");
  }

  save(item){
    return this.server("saveUserTag", {title: item.title, special: item.special});
  }

  update(item){
    return this.server("saveUserTag", {id: item.id, title:item.title, special: item.special}); 
  }

  remove(item){
    return this.server("removeUserTag", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/UserTagService.js